module.exports = __webpack_public_path__ + "img/qp.9e2f35bb.svg";